<template>
  <ContentExperiencesGrid
    :endpoint="`partners/${partner.slug}/experiences/all`"
    hide-partner
    :per-page="30"
    search-placeholder="Search all experiences"
    searchable
  />
</template>

<script setup lang="ts">
import type { Partner } from '~/types/partner'

const partner = useAttrs().partner as Partner
</script>
